/**
 * Returns if the provided object is empty, i.e. has no keys.
 * @param {object} obj
 * @return {bool}
 */
export const isEmpty = (obj) => Object.keys(obj).length === 0;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/utils/isEmpty.js